import React from "react";
import classNames from 'classnames';

import CardBase from "../../../ui/cards/CardBase";
import '../../../../assets/sass/pages/match-and-event-match-report/match-and-event-match-report-card.scss';

class MatchAndEventMatchReportCard extends CardBase {
    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => "Match Result";


    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => 'match-and-event-match-report-card';

    /**
     * Returns the classes of the card header component.
     * @returns {string} The card header classes.
     */
    cardHeaderClasses = () => classNames(`match-and-event-match-report-card--header`);
}

export default MatchAndEventMatchReportCard;
